import { Checkbox as BaseCheckbox } from "@base-ui-components/react/checkbox";
import { Field } from "@base-ui-components/react/field";
import { CheckIcon } from "lucide-react";
import {
  checkboxIconClasses,
  checkboxIndicatorClasses,
  checkboxLabelClasses,
  checkboxRootClasses,
  CheckBoxVariant,
} from "./Checkbox.style";
import { useId } from "react";
import { rootClasses } from "@/Field/Field.style";

export type CheckboxProps = BaseCheckbox.Root.Props &
  CheckBoxVariant & {
    /**
     * The label of the checkbox.
     */
    label?: string | React.ReactNode;
  };

const Checkbox = (props: CheckboxProps) => {
  const { label, id, name, className, colSpan, ...rest } = props;
  const generatedId = useId();
  const fieldId = id ?? generatedId;

  return (
    <Field.Root
      className={rootClasses({
        colSpan,
        className: typeof className === "string" ? className : "",
      })}
      name={name}
    >
      <Field.Label className={checkboxLabelClasses()}>
        <BaseCheckbox.Root
          {...rest}
          className={checkboxRootClasses()}
          id={fieldId}
        >
          <BaseCheckbox.Indicator className={checkboxIndicatorClasses()}>
            <CheckIcon className={checkboxIconClasses()} />
          </BaseCheckbox.Indicator>
        </BaseCheckbox.Root>
        {label}
      </Field.Label>
      <Field.Description />
      <Field.Error />
    </Field.Root>
  );
};

export default Checkbox;
